import React from "react";
import { Link, useRouteMatch } from "react-router-dom";

function NavBarButton({ path, children, dataCy }) {
  const match = useRouteMatch(path)?.isExact;

  return (
    <Link
      className={`
        mr-8
        inline-flex
        items-center
        px-1
        pt-1
        text-sm
        font-medium
        leading-5
        text-gray-500
        no-underline
        hover:no-underline
        hover:text-gray-500
        hover:border-gray-300
        border-b-2
        border-transparent
        ${
          match &&
          "border-zentake text-zentake hover:text-zentake hover:border-zentake"
        }
        transition
        duration-150
        ease-in-out
      `}
      data-cy={dataCy}
      to={path}
    >
      {children}
    </Link>
  );
}

export default NavBarButton;
